<template>
    <svg width="57.5" height="59.72" viewBox="0 0 57.5 59.72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m24.63,33.77c2.96,0 4.44,-1.39 4.44,-4.18s-1.48,-4.18 -4.44,-4.18l-11.23,0l0,8.36l11.23,0z"
            :fill="fill"
        />
        <path
            d="m53.7,14.34c-2.53,-4.5 -6.14,-8.01 -10.84,-10.54c-4.7,-2.53 -10.17,-3.8 -16.41,-3.8l-26.45,0l0,25.41l13.4,0l0,-9.04l11.37,0c4.22,0 7.56,1.15 10.04,3.46c2.47,2.31 3.71,5.6 3.71,9.87s-1.24,7.56 -3.71,9.87c-2.48,2.31 -5.82,3.46 -10.04,3.46l-11.69,0l0,16.7l13.38,0c6.24,0 11.71,-1.31 16.41,-3.92c4.7,-2.62 8.31,-6.2 10.84,-10.76c2.53,-4.56 3.8,-9.67 3.8,-15.35s-1.27,-10.85 -3.8,-15.35l-0.01,-0.01z"
            :fill="fill"
        />
    </svg>
</template>

<script setup>
    const props = defineProps({
        fill: {
            type: String,
            default: "#ffffff"
        }
    });
</script>
